export default {
  successIcon: {
    fill: '#00C853',
  },

  errorIcon: {
    fill: '#D50000',
  },
};
